module.exports = __webpack_public_path__ + "assets/img/sharefrend_graduate_new.62e29c51.png";